import React, { Suspense, useState } from "react";
import "./ForegtPassword.css";
import "bootstrap/dist/css/bootstrap.min.css";

import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import Loading from "../../components/Loading";
import {

  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import { Button, Form, FormGroup,  Input,  } from "reactstrap";
import { checkEmailValidation } from "../../Helpers/Validation";
import { connect,   } from "react-redux";
import { sendEmail } from "./../../actions/forgotPasswordAction";

const ForgetPassword = (props) => {
  const { frontLabelsName } = props.label;
  const{auth}=props
  const history = useHistory();
  const { isAuthenticated, loading } = auth;
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  window.scrollTo({ top: 0 });

  const onSubmit = (e) => {
    e.preventDefault();

    let validationFlag = true;
    setErrorEmail("");
    let errEmail = "";
    errEmail = checkEmailValidation(email, "lbl_email");
    if (errEmail) {
      validationFlag = false;
      setErrorEmail(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errEmail).length > 0
          ? frontLabelsName.filter((e) => e.key == errEmail)[0]["value"] ||
          errEmail
          : errEmail
        : errEmail);
    } else {
      validationFlag = true;
      setErrorEmail("");
    }

    let newObj = {
      email: email,
      resend: "1",
    };
    if (validationFlag) {
      props.sendEmail(newObj).then((res) => {
        if (res.status === 200) {
          setTimeout(() => {
            // history.push("/verify-otp");
            history.push({
              pathname: '/verify-otp',
              state: { detail: email }
            })
          }, 1500);
        }
      });
    }
  };

  if (isAuthenticated && !loading) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />

        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="main-login">
        <div className="forget-box">
          <Form>
            <div className="text-center">
              <h2 className="fr-box-set">
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_forgot_password")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_forgot_password"
                    )[0]["value"] || "lbl_forgot_password"
                    : "lbl_forgot_password"
                  : "lbl_forgot_password"}
              </h2>
              <p className="fr-set-p">

                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_forgot_pwd_details")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_forgot_pwd_details"
                    )[0]["value"] || "lbl_forgot_pwd_details"
                    : "lbl_forgot_pwd_details"
                  : "lbl_forgot_pwd_details"}
              </p>
            </div>
            <div className="set-pdd">
              <div className="set-width-dd new-frg">
                <FormGroup className="set-bg-feild set-dfd-fr">
                  <Input
                    type="text"
                    name="Email"
                    placeholder={frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_email")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_email"
                        )[0]["value"] || "lbl_email"
                        : "lbl_email"
                      : "lbl_email"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errorEmail && (
                    <span className="invalid_span">{errorEmail}</span>
                  )}
                </FormGroup>

                <div className="button-set mb-3">
                  {/* <Link to="/reset-password"> */}
                  <Button type="button" onClick={(e) => onSubmit(e)}>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_send")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_send"
                        )[0]["value"] || "lbl_send"
                        : "lbl_send"
                      : "lbl_send"}
                  </Button>
                  {/* </Link> */}
                </div>
              </div>

              {/* <div className="text-center">
                <p className="set-green-color">
                  Link to reset password has been sent to your registered email,
                  Please check.
                </p>
              </div> */}

              <div className="back-top-login text-center">
                <Link to="/login">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_back_login")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_back_login"
                      )[0]["value"] || "lbl_back_login"
                      : "lbl_back_login"
                    : "lbl_back_login"}
                </Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
})
export default connect(mapStateToProps, { sendEmail })(ForgetPassword);
